/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EmailLogsSortBy {
    CREATED = 'Created',
}
